module.exports = __webpack_public_path__ + "img/electricity.1ff08109.png";